export default __webpack_public_path__ + "static/wireframes-ef64ab9b889e1fd9ec1e053c2b82a2aa.png";